import { render, staticRenderFns } from "./TableActivitiesRestoreContainer.vue?vue&type=template&id=669989b8&"
import script from "./TableActivitiesRestoreContainer.vue?vue&type=script&lang=js&"
export * from "./TableActivitiesRestoreContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports